import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {UtilsService} from "../../shared/utils.service";
import {ApiRequestService} from "../../shared/api-request.service";
import {UserPublicProfileComponent} from "../../shared/user-public-profile/user-public-profile.component";
import {AssetTypeModel} from "../../models/asset-type.model";

@Component({
  selector: 'app-asset-types-view',
  templateUrl: './asset-types-view.component.html',
  styleUrls: ['./asset-types-view.component.scss']
})
export class AssetTypesViewComponent implements OnInit {

  asset_type: AssetTypeModel = new AssetTypeModel();

  constructor(
    @Inject(MAT_DIALOG_DATA) private id: number,
    private utils: UtilsService,
    private api: ApiRequestService
  ) { }

  ngOnInit() {
    const asset_type_id = this.id;
    if(asset_type_id) {
      this.getAssetType(asset_type_id);
    }
  }

  /**
   * Retrieves the Asset Type with the specified ID.
   * @param {number} id - The unique identifier of the asset type to retrieve.
   * @return {void}
   */
  private getAssetType (id: number) {
    this.api.makeRequest('get', `v2/asset-types/${id}`)
      .then((response) => {
        this.asset_type = response.data;
      })
      .catch((errorResponse) => {
        this.utils.handleAPIErrors(errorResponse);
      });
  }

  /**
   * Open the User's public profile dialog.
   * @param hash
   */
  onUserPublicView(hash: string) {
    this.utils.showComponentDialog(
      UserPublicProfileComponent,
      hash,
      { width: '90%' },
      () => {
        // Refresh the list regardless of how the dialog is closed.
      }
    );
  }

}
